const U = (id, w = 1920) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
  hero: "https://images.unsplash.com/photo-1717356600080-3d3a171407d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwZWxlY3RyaWMlMjBtaWNyb2NhciUyMG1pbGFuJTIwc3RyZWV0JTIwdXJiYW4lMjBsdXh1cnklMjBhdXRvbW90aXZlfGVufDB8fHx8MTc4OTc3MTkwOHww&ixlib=rb-4.1.0&q=85",
  manifesto: "/assets/zip-studio.webp",
  manifestoDuomo: "/assets/manifesto-duomo.webp",
  manifestoScuola: "/assets/manifesto-scuola.webp",
  manifestoParcheggio: "/assets/manifesto-parcheggio.webp",
  dimensions: U("photo-1519501025264-65ba15a82390"),
  ftouch: U("photo-1477959858617-67f85cf4f1df"),
  lifestyleFashion: U("photo-1483985988355-763728e1935b", 1400),
  lifestyleEditorial: U("photo-1469334031218-e382a71b716b", 1400),
  lifestyleArch: U("photo-1486406146926-c627a92ad1ab", 1400),
  lifestyleCafe: U("photo-1521017432531-fbd92d768814", 1400),
  electric: U("photo-1593941707882-a5bba14938c7"),
  interior: "https://images.unsplash.com/photo-1662197351685-155ded47cd70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw3fHxlbGVjdHJpYyUyMGNhciUyMGludGVyaW9yJTIwZGlnaXRhbCUyMGRhc2hib2FyZCUyMG1vZGVybiUyMGF1dG9tb3RpdmUlMjBkZXNpZ258ZW58MHx8fHwxNzg5NzcxOTA4fDA&ixlib=rb-4.1.0&q=85",
  interiorDash: "https://images.pexels.com/photos/10029877/pexels-photo-10029877.jpeg?auto=compress&cs=tinysrgb&w=1400",
  carBase: "/assets/colours/silver-grey.webp",
  testDrive: U("photo-1449965408869-eaa3f722e40d"),
  guideCity: "https://images.unsplash.com/photo-1633355309063-dfdb1d835f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxmdXR1cmlzdGljJTIwZWxlY3RyaWMlMjBtaWNyb2NhciUyMG1pbGFuJTIwc3RyZWV0JTIwdXJiYW4lMjBsdXh1cnklMjBhdXRvbW90aXZlfGVufDB8fHx8MTc4OTc3MTkwOHww&ixlib=rb-4.1.0&q=85",
  guideNight: U("photo-1519681393784-d120267933ba"),
  guideRoad: U("photo-1502877338535-766e1452684a"),
};
